(() => {
  if (window.__ikTbEngagementInstalled) return;
  window.__ikTbEngagementInstalled = true;
  const allowed = new Set(['xxl-team-bundle','teambuilding-bundle','teambuilding-bundle-2-0','kommuikationsbundle','perspektivwechsel-bundle','frobelturm-master-bundle','frobelturm-bundle','blind-silent-bundle','kreiselzeichner-bundle','mission-code-alpha','team-puzzle','feel-find','square-up','teamring','teambahn','kreiselzeichner','froebelturm','frobelturm-plus','frobelturm-plus-erweiterungsset','team-dynamik-chart-dokumentationsblock','wackeltisch','deep-zoom-challenge','teamloop','zauberstab','kugelkurier','laufband-walkingloop','mini-froebelturm','zollstock-kooperationsspiel','ufo','nagelratsel','team-domino','ferkelrennen','handabformset-fur-gruppenworkshops-oder-erlebnispadagogik','tastmemory-aus-holz-anleitung-als-pdf','augenbinde-teambuilding','e-book-teambuilding','deep-zoom-challenge-digitale-version']);
  const path = location.pathname.replace(/\/$/, '');
  const product = path.match(/\/products\/([^/]+)$/)?.[1];
  if (!(product ? allowed.has(product) : /\/collections\/teambuilding-kommunikationstraining$/.test(path))) return;
  const key = 'ik_tb_engaged_v1';
  let activeMs = 0, maxScroll = 0, lastTick = performance.now(), lastAction = lastTick;
  let sent = false, pending = false, previouslyAllowed = false;
  let metaReady, ownsMeta = false, metaInitialized = false;
  const pixelId = '4221966764780963';
  function prepareMeta() {
    if (metaReady) return metaReady;
    if (typeof window.fbq === 'function') return Promise.resolve(window.fbq);
    ownsMeta = true;
    metaReady = new Promise((resolve, reject) => {
      const fbq = window.fbq = function() {
        fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.onload = () => resolve(fbq);
      script.onerror = () => reject(new Error('Meta SDK unavailable'));
      document.head.appendChild(script);
    });
    return metaReady;
  }
  function consent() {
    try {
      const p = window.Shopify?.customerPrivacy;
      const c = p?.currentVisitorConsent();
      return c?.marketing === 'yes' && c?.analytics === 'yes' && p.marketingAllowed() && p.analyticsProcessingAllowed() && p.saleOfDataAllowed();
    } catch { return false; }
  }
  function eligibleNow() { return document.visibilityState === 'visible' && document.hasFocus(); }
  function action(event) {
    if (!event.isTrusted || !consent() || !eligibleNow()) return;
    lastAction = performance.now();
    if (event.type === 'scroll') {
      const distance = document.documentElement.scrollHeight - window.innerHeight;
      if (distance > 0) maxScroll = Math.max(maxScroll, Math.min(1, window.scrollY / distance));
    }
  }
  ['scroll','pointerdown','keydown','touchstart'].forEach(type => document.addEventListener(type, action, {passive:true}));
  document.addEventListener('visibilitychange', () => { lastTick = performance.now(); });
  window.addEventListener('focus', () => { lastTick = performance.now(); });
  window.addEventListener('blur', () => { lastTick = performance.now(); });
  window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}], () => {});
  const timer = window.setInterval(() => {
    const now = performance.now();
    const delta = Math.min(1000, Math.max(0, now - lastTick));
    lastTick = now;
    const permitted = consent();
    if (!permitted) { activeMs = 0; maxScroll = 0; previouslyAllowed = false; return; }
    if (!previouslyAllowed) { previouslyAllowed = true; lastAction = now; return; }
    try {
      const previous = Number(sessionStorage.getItem(key));
      if (previous && Date.now() - previous < 30 * 60 * 1000) { clearInterval(timer); return; }
    } catch { clearInterval(timer); return; }
    if (eligibleNow() && now - lastAction <= 20000) activeMs += delta;
    if (sent || pending || activeMs < 30000 || maxScroll < 0.5 || !eligibleNow()) return;
    pending = true;
    try {
      prepareMeta().then(fbq => {
        if (!consent() || !eligibleNow() || activeMs < 30000 || maxScroll < 0.5) return;
        if (ownsMeta && !metaInitialized) { fbq('init', pixelId); metaInitialized = true; }
        const eventId = window.crypto.randomUUID();
        fbq('trackSingleCustom', pixelId, 'IK_TB_Engaged', {
          content_category:'teambuilding', product_handle:product || '', active_seconds:Math.floor(activeMs / 1000),
          scroll_percent:Math.floor(maxScroll * 100), rule_version:'1', page_path:path
        }, {eventID:eventId});
        sent = true;
        sessionStorage.setItem(key, String(Date.now()));
        clearInterval(timer);
      }).catch(() => {}).finally(() => { pending = false; });
    } catch { pending = false; }
  }, 1000);
})();
